<template>
  <div @click="handleClickOut($event)">
    <base-drawer
      :open="openDrawer"
      :close="closedDrawer"
      :title="getTitle(targetItem)"
      @onClose="onDrawerClose()"
      :closeInFade="false"
      ref="catalogDrawer"
    >
      <!-- Contents -->
      <div v-show="!deleteMode.main">
        <category-form
          ref="category"
          v-show="targetItem.type === 'category'"
          v-on:saveItem="save"
          :setDeleteMode="setDeleteMode"
          @onScrollTo="scrollToSection"
        >
        </category-form>
        <simple-form ref="simple" v-show="targetItem.type === 'simple'" v-on:saveItem="save"></simple-form>
        <step-form ref="step" v-show="targetItem.type === 'step'" v-on:saveItem="save" :originCatalog="originCatalog" ></step-form>
        <flavor-form ref="flavor" v-show="targetItem.type === 'flavor'" v-on:saveItem="save" :originCatalog="originCatalog"></flavor-form>
        <drink-form ref="drink" v-show="targetItem.type === 'drink'" v-on:saveItem="save" :originCatalog="originCatalog"></drink-form>

        <!-- Options -->
        <base-card>
          <base-checkbox
            v-if="targetItem.type != 'category'"
            v-model="highlightItem"
            :checked="highlightItem"
            class="mb_15"
          >
            <p>{{ StringLanguage.highlightProduct }}</p>
          </base-checkbox>
          <base-checkbox v-model="hideItem" :checked="hideItem">
            <p>
              <span v-if="targetItem.type === 'category'">{{ StringLanguage.hideCategory }}</span>
              <span v-else>{{ StringLanguage.hideProduct }}</span>
            </p>
          </base-checkbox>
        </base-card>
      </div>

      <!-- Delete Confirm -->
      <div v-if="deleteMode.main">
        <base-card>
          <p class="text-delete">
            <span
              v-if="targetItem.type === 'category'"
            >{{ StringTemplate.replace(StringLanguage.warningCategoryMessage, {'{category}': targetItem.name} )}}</span>
            <span
              v-else
            >{{ StringTemplate.replace(StringLanguage.warningProductMessage, {'{product}': targetItem.name} )}}</span>
          </p>
        </base-card>
      </div>

      <!-- Actions -->
      <template v-slot:footer>
        <div v-if="deleteMode.main" class="d-flex">
          <base-button
            :text="StringLanguage.cancel"
            design="four"
            @click.prevent="deleteMode.main = false;"
            class="w-100 mr_7 big"
          />
          <base-button :text="StringLanguage.confirm" @click.prevent="del()" class="w-100 ml_7" />
        </div>
        <div v-else class="d-flex">
          <base-button
            v-if="targetItem._id"
            class="mr_15 big"
            design="four"
            @click.prevent="deleteMode.main = true"
          >
            <i class="fal fa-trash-alt fs-12"></i>
          </base-button>
          <base-button
            :text="targetItem._id ? StringLanguage.save : StringLanguage.create"
            @click.prevent="save()"
            class="w-100 big"
          />
        </div>
      </template>
    </base-drawer>
  </div>
</template>

<script>
import store from '@/store';
import BaseDrawer from "@/components/Drawer";
import BaseButton from "@/components/Button";
import BaseCard from "@/components/Card";
import BaseCheckbox from "@/components/Checkbox";

import CategoryForm from "@/containers/Catalog/Drawers/Category.vue";
import SimpleForm from "@/containers/Catalog/Drawers/Simple.vue";
import StepForm from "@/containers/Catalog/Drawers/Step.vue";
import FlavorForm from "@/containers/Catalog/Drawers/Flavor.vue";
import DrinkForm from "@/containers/Catalog/Drawers/Drink.vue";
import Builder from "easyjs/lib/Schema/Components/Builder";

import StringTemplate from "easyjs/lib/Tools/StringTemplate";

export default {
  data() {
    return {
      StringTemplate,
      targetItem: Builder.factory("Base"),
      openDrawer: false,
      closedDrawer: false,
      hideItem: false,
      highlightItem: false,
      sortMode: {
        main: false
      },
      deleteMode: {
        main: false,
        drink: null,
        pizza: null,
        step: null
      }
    };
  },
  props: {
    originCatalog: {}
  },
  methods: {
    setDeleteMode(deleteKey, value) {
      if (deleteKey !== 'main') this.deleteMode[deleteKey] = value;
    },
    handleClickOut(event) {
      let clickOnButton = false;
      const deleteModes = this.getDeleteModes();

      const cards = document.querySelectorAll('.base-card-to-listen');

      [...cards].forEach(card => {
        for (const button of [...card.querySelectorAll("button")]) {
          if (this.buttonHadClick(button, { x: event.clientX, y: event.clientY })) {
            clickOnButton = true;
            break;
          }
        }
      });

      // forçando o click do botão remover quando collapse está aberto
      clickOnButton = event.toElement.id === 'deleteOrBack' ||
                      event.toElement.innerText === 'Remover' ||
                      event.toElement.innerText === 'Voltar';

      deleteModes.forEach(item => {
        if (item) {
          const [key] = Object.keys(item);

          if (item[key] !== null) {
            if (item[key] && !clickOnButton) {
              Object.keys(this.deleteMode[key]).forEach(itemKey => {
                this.deleteMode[key][itemKey] = false;
              });
            }
          }
        }
      });
    },
    buttonHadClick(button, clickArea) {
      const horizontal = {
        init: button.getBoundingClientRect().left,
        end: button.getBoundingClientRect().left + button.getBoundingClientRect().width,
      };

      const vertical = {
        init: button.getBoundingClientRect().top,
        end: button.getBoundingClientRect().top + button.getBoundingClientRect().height,
      };

      const clickHorizontal = clickArea.x >= horizontal.init && clickArea.x <= horizontal.end;
      const clickVertical = clickArea.y >= vertical.init && clickArea.y <= vertical.end;

      return clickHorizontal && clickVertical;
    },
    getDeleteModes() {
      const deleteKeys = Object.keys(this.deleteMode);

      const deleteModes = deleteKeys.map(key => {
        if (key !== 'main') {
          return {
            [key]: this.deleteMode[key]
          }
        }
      });

      return deleteModes;
    },
    getTitle(targetItem) {
      let sTitle;
      sTitle = targetItem.new
        ? `${StringLanguage.create} `
        : `${StringLanguage.edit} `;
      sTitle +=
        targetItem.type === "category"
          ? StringLanguage.category
          : StringLanguage.product;
      return sTitle;
    },
    closeDrawer() {
      this.closedDrawer = !this.closedDrawer;
      this.targetItem = null;
      this.$emit("clean-model");
    },
    confirmClose() {
      return confirm(StringLanguage.confirmCloseCatalog).then(r => {
        return r;
      });
    },
    changeModel(item, parent) {
      if (!this.sortMode.main) {
        this.openDrawer = !this.openDrawer;
        this.hideItem = !item.show;
        this.highlightItem = item.highlight;
        if(item.type == 'category' && !item._id) {
          item.mode = 'pizza'
        }

        this.targetItem = item;

        if (parent) {
          parent = this.originCatalog.getItemsByParam("_id", parent)[0];
        }

        let itemBuild = item ? Builder.mountSchema(JSON.parse(JSON.stringify(item))) : {};
        let parentBuild = parent ? Builder.mountSchema(JSON.parse(JSON.stringify(parent))) : {};
        this.$refs[this.targetItem.type].setModel(itemBuild, parentBuild);
      }
    },
    onDrawerClose() {
      this.deleteMode.main = false;
      store.commit('catalog/setReorderedSteps', false);
    },
    validateItem(item) {
      if(item.type == 'category') {
        if(!item.name) {
          alert(`${StringLanguage.errorEmptyName} para sua categoria.`);
          return false;
        }

        if(item.mode == 'pizza') {
          if(item.sizes.length > 1) {

            //Verificar se existem ao menos duas categorias com nome configurado
            let correctSizes = item.sizes.filter(s => !!s.name);
            if(correctSizes.length < 2) {
              alert(StringLanguage.errorEmptyMaxOrSizeName);
              return false;
            }

            //Verificar se esses tamanhos tem o máximo de itens configurado
            if(correctSizes.filter(s => !s.max).length > 0) {
              alert(StringLanguage.errorEmptyMaxOrSizeName);
              return false;
            }

          } else {
            //Verificar se esse tamanho tem o máximo de itens configurados configurado
            if(!!!item.sizes[0].max) {
              alert(StringLanguage.errorEmptyMax);
              return false;
            }
          }
        }

        if(item.mode == 'drink') {
          if(item.default_sizes) {
            if(item.sizes.length == 0) {
              alert(`${StringLanguage.errorSizeRequired} para o seu produto.`);
              return false;
            } else {
              const isValidSizes = item.sizes.filter(s => !s.delete).reduce((c, s) => c && !!s.unit && !!s.amount && !!s.package, true)
              if(!isValidSizes) {
                alert(`O volume, medida e embalagem dos tamanhos são obrigatórios`);
                return false;
              }
            }
          }
        }
      } else {
        if(!item.name) {
          alert(`${StringLanguage.errorEmptyName} para o seu produto.`);
          return false;
        }

        const hasSizeSaleError = item.sizes.find(size => size.price > 0 && size.price <= size.originalPrice);
        const hasSaleError = item.price > 0 && item.price <= item.originalPrice
        if(!!hasSizeSaleError || !!hasSaleError) {
          alert(`Preço de promoção deve ser menor que o valor.`);
          return false;
        }

        /* Aplicando regra de promoção:
          - menor preço maior que zero se refere a promoção (assume a prop price)
          - outro valor fica na prop de apoio originalPrice
        */
        if (item.sizes.length) {
          item.sizes.map(size => {
            if (size.originalPrice > 0 && size.originalPrice < size.price) {
              let aux = size.price;
              size.price = size.originalPrice;
              size.originalPrice = aux;
            }
          })
        } else {
          if (item.originalPrice > 0 && item.originalPrice < item.price) {
            let aux = item.price;
            item.price = item.originalPrice;
            item.originalPrice = aux;
          }
        }

        if(item.type == 'drink') {
          const parentProduct = item.parent_ref;
          const sizesLength = item.sizes.filter(s => !s.delete).length;

          if(!item.group) {
            alert(`${StringLanguage.errorDrinkGroupRequired}`);
            return false;
          }

          if(!parentProduct.default_sizes) {
            if(sizesLength == 0) {
              alert(`${StringLanguage.errorSizeRequired} para o seu produto.`);
              return false;
            } else {
              const isValidSizes = item.sizes.filter(s => !s.delete).reduce((c, s) => c && !!s.unit && !!s.amount && !!s.package, true)
              if(!isValidSizes) {
                alert(`O volume, medida e embalagem dos tamanhos são obrigatórios`);
                return false;
              }
            }
          }
        }
      }

      //verifica se tem disponibilidade configurada
      if(item.availability) {
        //verifica se ao menos 1 dia da semana foi selecionado
        if(!item.availability.daysOfTheWeek) {
          alert(StringLanguage.errorEmptyDay);
          return false;
        }

        //verifica se tem algum período
        if(!item.availability.periods.length) {
          alert(StringLanguage.errorEmptyPeriod);
          return false;
        }

        //percorre períodos para validação
        for(let period of item.availability.periods) {
          //verifica se algum horário não está preenchido
          if(!period.beginTime || !period.endTime) {
            alert(StringLanguage.errorInvalidPeriod);
            return false;
          }

          //aplica validação de horário informado
          if(!this.validateTime(period.beginTime) || !this.validateTime(period.endTime)) {
            alert(StringLanguage.errorInvalidPeriod);
            return false;
          }

          //verifica se o horário inicial é maior que o final
          if(+(period.beginTime.replace(':', '')) > +(period.endTime.replace(':', ''))) {
            alert(StringLanguage.errorInvalidTime);
            return false;
          }
        };
      }

      return true;
    },
    validateTime(value) {
      let [hours, minutes] = value.replace(':', '').padEnd(4, '0').match(/.{1,2}/g);
      let date = new Date(0,0,0, hours, minutes);
      if(hours != date.getHours() || minutes != date.getMinutes()) {
        return false;
      }
      return true;
    },
    save(item) {
      let itemToSave = item ? item : this.$refs[this.targetItem.type].getItem();
      if(!this.validateItem(itemToSave)) {
        if(this.$refs[this.targetItem.type].highlightErrorFields) {
          this.$refs[this.targetItem.type].highlightErrorFields();
        }

        return;
      }

      itemToSave.show = !this.hideItem;

      if (itemToSave.type != "category") {
        itemToSave.highlight = this.highlightItem;
      }

      if(itemToSave.sizes.length > 0) {
        itemToSave.sizes = itemToSave.sizes.filter(i => !!i.name);
      }

      let sizesIds = itemToSave.sizes.map(s => s._id);

      if(itemToSave.edges.length > 0) {
        itemToSave.edges = itemToSave.edges.map((i) => {
          if(!i.name) {
            if(i.new) {
              return null
            }
            i.delete = true
          }

          return i
        }).filter(i => !!i).map((i) => {
            i.sizes = i.sizes.filter(s => sizesIds.indexOf(s._id) > -1)
            return i;
        });
      }

      if(itemToSave.extra_ingredients.length > 0) {
        itemToSave.extra_ingredients = itemToSave.extra_ingredients.map((i) => {
          if(!i.name) {
            if(i.new) {
              return null
            }
            i.delete = true
          }

          return i
        }).filter(i => !!i).map((i) => {
            i.sizes = i.sizes.filter(s => sizesIds.indexOf(s._id) > -1)
            return i;
        });
      }

      if(itemToSave.doughs.length > 0) {
        itemToSave.doughs = itemToSave.doughs.map((i) => {
          if(!i.name) {
            if(i.new) {
              return null
            }
            i.delete = true
          }

          return i
        }).filter(i => !!i).map((i) => {
            i.sizes = i.sizes.filter(s => sizesIds.indexOf(s._id) > -1)
            return i;
        });
      }

      this.closedDrawer = !this.closedDrawer;
      this.$emit("updateCatalog", itemToSave);
    },
    del(item) {
      let itemToDelete = item ? item : this.$refs[this.targetItem.type].getItem();
      itemToDelete.delete = true;
      this.closedDrawer = !this.closedDrawer;
      this.$emit("updateCatalog", itemToDelete);
    },
    scrollToSection(section) {
      this.$refs.catalogDrawer.scrollTo(section, 500, { force: true });
    }
  },
  components: {
    CategoryForm,
    SimpleForm,
    StepForm,
    FlavorForm,
    DrinkForm,
    BaseDrawer,
    BaseButton,
    BaseCard,
    BaseCheckbox
  }
};
</script>
<style scoped>
.text-delete {
  font-size: 1.4em;
  color: #bbb;
  line-height: 1.2;
}
.product-key {
  font-size: 1.4em;
  color: #555;
  font-weight: 300;
}
</style>